import { css } from '@/styled-system/css';

export const panelOutlet = css({
  position: 'absolute',
  inset: 0,
  zIndex: 'zIndexOverParent',
  backgroundColor: 'hpxWhite',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  willChange: 'transform',
  transitionProperty: 'transform',
  transitionDuration: '300ms',
  transitionTimingFunction: 'ease-out',
});

export const panelOutletHidden = css({
  transform: 'translateX(100%)',
  pointerEvents: 'none',
});

export const panelOutletVisible = css({
  transform: 'translateX(0)',
});

export const panelHeader = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: '48px',
  flexShrink: 0,
  px: '1x',
  py: '1x',
  position: 'sticky',
  top: 0,
  bg: 'hpxWhite',
  zIndex: 'zIndexParent',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'hpxGrey400',
});

export const panelHeaderColumns = css({
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  width: '100%',
  gap: '1x',
});

export const panelHeaderColumn1 = css({
  justifySelf: 'start',
});

export const panelHeaderColumn2 = css({
  justifySelf: 'center',
});

export const panelHeaderColumn3 = css({
  justifySelf: 'end',
  display: 'flex',
  gap: '1x',
  alignItems: 'center',
});

export const panelHeaderTitle = css({
  fontSize: 'lg',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  textAlign: 'center',
});

export const panelBody = css({
  flex: 1,
});
